/**
 * Remove currency from price
 * @param val
 */
function clean_price (val) {
    if (typeof val === 'number') {
        val = val.toString()
    }
    if (typeof val !== 'string') {
        return val
    }

    return val.replace(/[^\s0-9]/g, '').trim()
}

/**
 * Format a number with grouped thousands
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {*}
 */
function number_format (number, decimals, dec_point, thousands_sep) {
    //
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +	 bugfix by: Michael White (http://crestidg.com)

    var i, j, kw, kd, km

    // input sanitation & defaults
    if (isNaN(decimals = Math.abs(decimals))) {
        decimals = 2
    }
    if (dec_point === undefined) {
        dec_point = ','
    }
    if (thousands_sep === undefined) {
        thousands_sep = '.'
    }

    i = parseInt(number = (+number || 0).toFixed(decimals)) + ''

    if ((j = i.length) > 3) {
        j = j % 3
    }
    else {
        j = 0
    }

    km = (j ? i.substr(0, j) + thousands_sep : '')
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands_sep)
    //kd = (decimals ? dec_point + Math.abs(number -
    // i).toFixed(decimals).slice(2) : "");
    kd = (decimals
        ? dec_point +
        Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2)
        : '')

    return km + kw + kd
}

/**
 * Format price
 * @param val
 * @returns {*}
 */
function format_price (val) {
    var result = number_format(parseFloat(val), 2, '.', ' ')
    if (result.match(/\.00$/)) {
        result = result.substring(0, result.length - 3)
    }
    return result
}

function getNoun(number, values) {
    if (typeof values == 'string') {
        values = values.split('|')
    }
    if (typeof values !== 'object' || values.length !== 3) {
        return '';
    }
    var n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return values[2];
    }
    n %= 10;
    if (n === 1) {
        return values[0];
    }
    if (n >= 2 && n <= 4) {
        return values[1];
    }
    return values[2];
}

/**
 * Show alert message
 * @param msg
 */
function show_alert (msg) {
    if (msg) {
        setTimeout(function () {
            alert(msg)
        }, 200)
    }
}

$(document).ready(function () {
    var dadata_key = '2cc1d6913ffa080df249715a3c21cd0db67652a6';

    //Street Autocomplete
    var init_street_suggestions = function ($container) {
        var $input = $container.find('.js-street-search')
        var constraints = {}
        var restrict_value = false
        if ($input.data('city')) {
            constraints = {
                label: "",
                locations: {
                    region: $input.data('region'),
                    city: $input.data('city')
                }
            }
            restrict_value = true
        }
        $input.suggestions({
            token: dadata_key,
            type: 'ADDRESS',
            count: 5,
            bounds: "city-house",
            constraints: constraints,
            // в списке подсказок не показываем область
            restrict_value: restrict_value,
            /* Вызывается, когда пользователь выбирает одну из подсказок */
            onSelect: function (suggestion) {
                var data = suggestion.data
                /**
                 * @var {{
                 *  street_kladr_id:string,
                 *  street:string,
                 *  street_with_type:string
                 *  house:string
                 *  block_type:string
                 *  block:string
                 *  flat_type:string
                 *  flat:string
                 *  }} data
                 */
                $container.find('.js-address-street').val(data.street_with_type)
                var house = data.house
                if (data.block) {
                    house += ' ' + data.block_type + ' ' + data.block;
                }
                $container.find('.js-address-house').val(house)
                if (!house) {
                    $input.siblings('.error').remove()
                    $input.after($('<label>').addClass('error').text('Введите номер дома'))
                } else {
                    $input.siblings('.error').remove()
                }
            }
        })
    }

    /**
     * Update cart cost and etc after cart change
     * @param data
     */
    function update_cart (data) {
        $('.js-cart-count').html(data.count)
        $('.js-cart-total').html(clean_price(data.total))
        $('.js-cart-discount').html(clean_price(data.discount))
        $('.js-cart-count-unit').each(function () {
            var $this = $(this)
            $this.html(getNoun(data.count, $this.data('unit')))
        })
        var discount = parseFloat(data.discount_numeric);
        if (discount) {
            $('.js-cart-discount-block').addClass('active')
            var total = parseFloat(clean_price(data.total).replace(/\s/g, ''))
            var cart_total = total + discount
            var discount_percent = cart_total ? Math.round(discount / cart_total * 100) : 0
            $('.js-cart-discount-percent').html(discount_percent)
        }
        else {
            $('.js-cart-discount-block').removeClass('active')
            $('.js-cart-discount-percent').html(0)
        }
        if (data.count) {
            $('.js-cart-holder').removeClass('empty')
        }
        else {
            $('.js-cart-holder').addClass('empty')
        }

        if (typeof data.discount_hint !== 'undefined') {
            $('.js-cart-discount-hint-block').html(data.discount_hint)
        }

        // if (data.add_affiliate_bonus) {
        //     $(".js-affiliate").show().html(data.add_affiliate_bonus);
        // } else {
        //     $(".js-affiliate").hide();
        // }
        //
        // if (data.affiliate_discount) {
        //     $('.js-affiliate-discount-available').html(data.affiliate_discount);
        // if ($('.js-affiliate-discount').data('use')) {
        // $('.js-affiliate-discount').html('&minus; ' +
        // data.affiliate_discount); } }
    }

    function update_cart_discount_hint () {
        $.ajax({
            url: '/ajax/cart/data/',
            type: 'post',
            dataType: 'json',
        }).done(function (response) {
            if (response.status === 'ok' && typeof response.data.discount_hint !== 'undefined') {
                $('.js-cart-discount-hint-block').html(response.data.discount_hint)
            }
        })
    }

    /**
     * Update product cost after product change
     * @param $container
     * @param product_data
     */
    function update_product ($container, product_data) {
        var price = product_data['default_price']
        var available = true
        var sku_id = false
        if (typeof product_data['features'] === 'undefined') {
            var $option = $container.find('.js-product-variants option:selected')
            if ($option.length) {
                price = $option.data('price')
                available = $option.data('available')
                sku_id = $option.val()
            }
        }
        else {
            var key = ''
            $container.find('.js-product-feature:checked').each(function () {
                key += $(this).data('feature-id') + ':' + $(this).val() + ';'
            })
            var sku = product_data.features[key]
            if (sku) {
                price = sku.price
                sku_id = sku.id
            }
            available = sku.available
        }

        available = available && (!sku_id || product_data.stock[sku_id].total_count !== 0.0)

        var quantity = $container.find('[name=quantity]').val()
        if (quantity) {
            price = price * quantity
        }

        $container.find('.js-product-cost').text(format_price(price))
        if (sku_id) {
            $container.find('.js-product-stock-limit').text(product_data.stock[sku_id]['text_stock_limit'])
            $container.find('.js-product-next-delivery').text(product_data.stock[sku_id]['text_next_delivery'])
        }

        if (available) {
            $container.find('.js-cart-add-btn').show()
            $container.find('.js-cart-unavailable-btn').hide()
        }
        else {
            $container.find('.js-cart-add-btn').hide()
            $container.find('.js-cart-unavailable-btn').show()
        }
    }

    // On change service modifier
    $(document).on('change', '.product__container .js-product-service', function () {
        var $this = $(this)
        if ($this.data('first-disabled')) {
            var $input = $('.product__container [data-service-toggle="' + $this.data('service-id') + '"]')
            $input.prop('disabled', $this.find('option:eq(0)').is(':selected'))
        }
    })

    // On change product modifier
    $(document).on('change', '.product__container .js-product-cost-modifier', function () {
        update_product($(this).closest('.product__container'),
            window.product_data)
    })

    // On add to cart
    $(document).on('submit', 'form.js-cart-add', function () {
        var $f = $(this)
        $.post($f.attr('action') + '?html=1', $f.serialize(),
            function (response) {
                if (response.status === 'ok') {
                    if (response.data['gtm']) {
                        $(document).trigger('cartAdd', ['Product', response.data['gtm']['products']])
                    }
                    update_cart(response.data)
                    update_cart_discount_hint()
                }
                else if (response.status === 'fail') {
                    if (typeof response.data['count'] !== 'undefined') {
                        update_cart(response.data)
                        update_cart_discount_hint()
                    }
                    show_alert(response.errors)
                }
            }, 'json')
        return false
    })

    var last_change_timer = null
    var change_interval = 700
    // On change in cart
    $(document).on('change', '.shopcart .js-cart-item-count', function (e) {
        if (!window.is_number_init) {
            return true
        }
        var $input = $(this),
            $item = $input.closest('.shopcart__item'),
            $total = $item.find('.js-cart-item-total'),
            $total_old = $item.find('.js-cart-item-old-price'),
            price = parseFloat($input.data('price')),
            old_price = parseFloat($input.data('old-price'))

        $total.text(format_price(parseInt($input.val()) * price))
        $total_old.text(format_price(parseInt($input.val()) * old_price))

        clearTimeout(last_change_timer)
        last_change_timer = setTimeout(function () {
            $.ajax({
                url: 'save/',
                data: {html: 1, id: $item.data('id'), quantity: $input.val()},
                dataType: 'json',
                type: 'post'
            }).done(function (response) {
                $total.text(clean_price(response.data.item_total))
                if (response.data.q) {
                    $input.val(response.data.q)
                    $total_old.text(clean_price(old_price * parseInt(response.data.q)))
                }
                else {
                    $input.removeClass('error')
                }
                if (response.data['gtm']) {
                    if (response.data['gtm']['action'] === 'add') {
                        $(document).trigger('cartAdd', ['Cart', response.data['gtm']['products']])
                    } else {
                        $(document).trigger('cartRemove', ['Cart', response.data['gtm']['products']])
                    }
                }
                if (response.data.error) {
                    show_alert(response.data.error)
                    setTimeout(function () {
                    }, 500)
                }
                update_cart(response.data)
                update_cart_discount_hint()
            })
        }, change_interval)
    })

    // On delete from cart
    $(document).on('click', '.shopcart .js-cart-delete', function (e) {
        var $item = $(this).closest('.shopcart__item')
        $.post('delete/', {html: 1, id: $item.data('id')}, function (response) {
            if (response.data['gtm']) {
                $(document).trigger('cartRemove', ['Cart', response.data['gtm']['products']])
            }
            if (response.data.count === 0) {
                location.reload()
            }
            update_cart(response.data)
            update_cart_discount_hint()
        }, 'json')
    })

    // Quick order
    function quickUpdateCart($input) {
        var $total = $input.closest('.catalog__table-row').find('.js-quickorder-item-total')
        if ($input.val() === $input.data('request-value')) {
            return
        }
        $input.data('request-value', $input.val())

        if ($input.data('cart_id')) {
            var is_delete = parseInt($input.val()) === 0
            $.ajax({
                url: !is_delete ? '/cart/save/' : '/cart/delete/',
                data: {html: 1, id: $input.data('cart_id'), quantity: $input.val()},
                dataType: 'json',
                type: 'post'
            }).done(function (response) {
                var item_total = 0; //For delete
                if (!is_delete) {
                    //For change
                    item_total = clean_price(response.data.item_total);
                    if (response.data.q) {
                        $input.val(response.data.q)
                    }
                } else {
                    $input.data('cart_id', null)
                }
                $total.text(item_total)
                if (response.data['gtm']) {
                    if (response.data['gtm']['action'] === 'add') {
                        $(document).trigger('cartAdd', ['QuickOrder', response.data['gtm']['products']])
                    } else {
                        $(document).trigger('cartRemove', ['QuickOrder', response.data['gtm']['products']])
                    }
                }
                if (response.data.error) {
                    show_alert(response.data.error)
                    setTimeout(function () {
                    }, 500)
                }
                update_cart(response.data)
            })
        } else {
            $.post('/cart/add/?html=1', {'product_id': $input.data('product_id'), 'sku_id': $input.data('sku_id'), 'quantity': $input.val()},
                function (response) {
                    if (response.status === 'ok') {
                        $input.data('cart_id', response.data.item_id)
                        if (response.data.q) {
                            $input.val(response.data.q)
                            $total.text(clean_price(response.data.item_total))
                        }
                        //$total.text(format_price($input.data('price')))
                        update_cart(response.data)
                        if (response.data['gtm']) {
                            $(document).trigger('cartAdd', ['QuickOrder', response.data['gtm']['products']])
                        }
                    }
                    else if (response.status === 'fail') {
                        if (response.data.q) {
                            $input.val(response.data.q)
                            $total.text(clean_price(response.data.item_total))
                        } else {
                            $input.val(0)
                            $total.text(0)
                        }
                        if (typeof response.data['count'] !== 'undefined') {
                            update_cart(response.data)
                        }
                        show_alert(response.errors)
                    }
                }, 'json')
            return false
        }
    }

    function quickCalcItemPrice ($input) {
        var $total = $input.closest('.catalog__table-row').find('.js-quickorder-item-total')

        $total.text(format_price(parseInt($input.val()) * parseFloat($input.data('price'))))
    }

    $(document).on('change', '.js-quickorder-item-count', function (e) {
        if (!window.is_number_init) {
            return true
        }
        var $input = $(this)
        if ($input.val() === '') {
            return true
        }

        quickCalcItemPrice($input)
        clearTimeout(last_change_timer)
        last_change_timer = setTimeout(function() {
            quickUpdateCart($input)
        }, change_interval)
    })

    $(document).on('focus', '.js-quickorder-item-count', function (e) {
        var $input = $(this)
        $input.data('old-value', $input.val())
    })

    $(document).on('blur', '.js-quickorder-item-count', function (e) {
        var $input = $(this),
            oldValue = $input.data('old-value')
        if ($input.val() === '') {
            $input.val(typeof oldValue !== 'undefined' ? oldValue : 1)
        }

        quickCalcItemPrice($input)
        quickUpdateCart($input)
    })

    //Activate coupon
    $(document).on('submit', '.js-form-coupon', function (e) {
        e.preventDefault()
        var $form = $(this),
            $coupon = $form.find('[name=coupon]'),
            $status = $form.siblings('.form-promo__status'),
            $wrapper = $form.closest('.form-promo-wrap')

        $status.text('').removeClass('error success')
        $.ajax({
            url: '/ajax/cart/coupon/add/',
            type: 'post',
            dataType: 'json',
            data: {'coupon_code': $coupon.val()},
        }).done(function (response) {
            if (response.status === 'ok') {
                update_cart(response.data)
                $wrapper.addClass('coupon-activated')
                $coupon.prop('disabled', true)
            }
            else {
                $status.text($status.data('error')).addClass('error')
                $wrapper.removeClass('coupon-activated')
            }
        })
    })

    $(document).on('reset', '.js-form-coupon', function (e) {
        e.preventDefault()
        var $form = $(this),
            $coupon = $form.find('[name=coupon]'),
            $wrapper = $form.closest('.form-promo-wrap')

        $.ajax({
            url: '/ajax/cart/coupon/remove/',
            type: 'post',
            dataType: 'json',
        }).done(function (response) {
            if (response.status === 'ok') {
                update_cart(response.data)
                $wrapper.removeClass('coupon-activated')
                $wrapper.show()
                $coupon.prop('disabled', false)
                $coupon.val('')
                $form.find('.btn-apply').removeClass('active')
            }
        })
    })

    //Activate hidden flag for register user if password not empty
    $(document).on('change', '.js-checkout-contact [name=password]', function () {
        if ($(this).val().length) {
            $('.js-checkout-contact [name=create_user]').val(1)
            $('.js-checkout-contact [name=login]').val($('.js-checkout-contact [name="customer[email]"]').val())
        }
        else {
            $('.js-checkout-contact [name=create_user]').val(0)
        }
    })

    //https://stackoverflow.com/questions/26657353/date-on-ios-device-returns-nan
    function parse_datetime (date) {
        var arr = date.split(/[- :]/)
        if (typeof arr[5] === 'undefined') {
            arr[5] = '00'
        }
        date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])

        return date
    }

    function update_delivery_dates ($container) {
        var $wrapper = $container.find('.js-delivery-intervals-container'),
            $dates = $container.find('.js-delivery-date')

        if ($wrapper.length === 0 || $dates.length === 0) {
            return false
        }

        var intervals_config = $wrapper.data('intervals')
        if (typeof intervals_config === 'undefined' || typeof intervals_config['dates'] === 'undefined' || !intervals_config['dates'].length) {
            return false
        }
        var current_date_time = new Date()
        var current_selected_date = $dates.val() || $dates.data('selected')
        var $options = []
        intervals_config['dates'].forEach(function (date) {
            var option_dt_to = parse_datetime(date['key'] + ' ' + date['available_time_to'])
            if (option_dt_to >= current_date_time) {
                var $option = $('<option>').val(date['key']).addClass('product__option').html(date['label'])
                if (date['key'] === current_selected_date) {
                    $option.prop('selected', true)
                }
                $options.push($option)
            }
        })
        $dates.empty().append($options)
        if (!$dates.find('option:selected').length) {
            $dates.find('option:eq(0)').prop('selected', true)
        }

        update_delivery_intervals($container)

        return true
    }

    function update_delivery_intervals ($container) {
        var $wrapper = $container.find('.js-delivery-intervals-container'),
            $dates = $container.find('.js-delivery-date'),
            $intervals = $container.find('.js-delivery-interval'),
            selected_date = $dates.val()

        if ($wrapper.length === 0 || $intervals.length === 0) {
            return false
        }
        var intervals_config = $wrapper.data('intervals')
        if (typeof intervals_config === 'undefined' || typeof intervals_config['intervals'] === 'undefined' || !intervals_config['intervals'].length) {
            return false
        }

        var current_date_time = new Date()
        var selected_interval = $intervals.data('selected')
        var $options = []
        intervals_config['intervals'].forEach(function (interval) {
            var option_dt_to = parse_datetime(selected_date + ' ' + interval['available_to'])
            if (option_dt_to >= current_date_time && interval['dates'].indexOf(selected_date) >= 0) {
                var $option = $('<option>').val(interval['key']).addClass('product__option').html(interval['label'])
                if (interval['key'] === selected_interval) {
                    $option.prop('selected', true)
                }
                $options.push($option)
            }
        })
        $intervals.empty().append($options)
        if (!$intervals.find('option:selected').length) {
            $intervals.val($intervals.find('option:eq(0)').val())
        }

        return true
    }

    function change_shipping_form (shipping_id) {
        var $forms = $('.js-shipping-form')
        $forms.hide()
        $forms.find('input,select,textarea').prop('disabled', true)
        var $shipping_form = $('#shipping-form-' + shipping_id)
        $shipping_form.find('input,select,textarea').prop('disabled', false)
        var $disabled_fields_block = $shipping_form.data('fallback') ? $shipping_form.find('.js-shipping-fields') : $shipping_form.find('.js-shipping-fields-fallback')
        if ($disabled_fields_block.length) {
            $disabled_fields_block.find('input,select,textarea').prop('disabled', true)
        }
        $shipping_form.show()
        update_select2($shipping_form)
        $shipping_form.find('.js-shipping-rate').trigger('change')
        update_delivery_dates($shipping_form)
        var country = $('.js-country-select').val()
        if (country === 'rus') {
            $shipping_form.find('.js-shipping-courier-world').hide()
            $shipping_form.find('.js-shipping-courier-rus').show()
            init_street_suggestions($shipping_form)
        } else {
            $shipping_form.find('.js-shipping-courier-rus').hide()
            $shipping_form.find('.js-shipping-courier-world').show()
        }

        $(document).trigger('shippingChange', [$('#shipping-' + shipping_id).data('gtm-name')])
    }

    function change_payment_form (payment_id) {
        var $forms = $('.js-payment-form')
        $forms.hide()
        $forms.find('input,select,textarea').prop('disabled', true)
        var $payment_form = $('#payment-form-' + payment_id)
        $payment_form.find('input,select,textarea').prop('disabled', false)
        $payment_form.show()
        update_select2($payment_form)
        init_inn_suggestions($payment_form)
        $(document).trigger('paymentChange', [$('#payment-' + payment_id).data('gtm-name')])
    }

    //Store rates for delivery
    var rates = []

    function request_update_checkout (request_rates, force_update_shipping) {
        var $shop_cart_form = $('form.js-checkout-form')
        if (typeof request_rates === 'undefined') {
            request_rates = false
        }
        var $shipping_checked = $('.js-checkout-form [name=shipping_id]:checked')
        var post_data = $shop_cart_form.serializeArray()
        post_data.push({
            name: 'request_rates',
            value: request_rates ? 1 : 0,
        })

        if ($shipping_checked.data('selected')) {
            post_data.push({
                name: 'shipping_id',
                value: $shipping_checked.data('selected')
            })
        }
        // Request unavailable payments and shippings
        $.ajax({
            url: '/ajax/checkout/data/',
            type: 'post',
            dataType: 'json',
            data: post_data,
        }).done(function (response) {
            //Hide unavailable shippings and update cost for available
            $.each(response.data['shipping'], function (i, shipping) {
                var $shipping = $('.js-shipping[data-id=' + shipping['id'] + ']'),
                    $shipping_form = $('#shipping-form-' + shipping['id'])
                if (shipping['available']) {
                    $shipping.removeClass('js-shipping-disabled')
                    if (request_rates) {
                        //Update cost and estimate date
                        $shipping.find('.js-shipping-cost').html(shipping['rate_html'])
                        var est = shipping['est_delivery']
                        if (est.length && (shipping.rate || shipping.rate === 0 || shipping.rate === '')) {
                            est = ', ' + est
                        }
                        $shipping.find('.js-shipping-est-delivery').html(est)
                    }

                    //Update rates
                    var $shipping_ext_rates = $shipping_form.find('.js-external-rates')
                    if ($shipping_ext_rates.length && request_rates) {
                        //Blocks for fields than depend on rate type
                        var $fields_block = $shipping_ext_rates.closest('.js-shipping-fields')
                        var $fallback_block = $shipping_form.find('.js-shipping-fields-fallback')
                        var selected_rate_id = response.data['rate_id'][shipping['id']]
                        //Clear and add new rates
                        $shipping_ext_rates.empty()
                        var is_error = shipping['error']
                        if (!is_error) {
                            var rates_options = []
                            $.each(shipping['rates'], function (id, rate) {
                                if (rate['label'] == null) {
                                    is_error = true
                                    return false
                                }
                                var $option = $('<option>').
                                    attr('value', id).
                                    addClass('product__option').
                                    data('rate', rate['rate']).
                                    html((typeof rate['label'] !== 'undefined' ? rate['label'] : rate['name']) + ' — ' + rate['rate_html'])
                                if (rate['type']) {
                                    $option.data('type', rate['type'])
                                }
                                if (rate['comment']) {
                                    $option.data('comment', rate['comment'])
                                }
                                if (selected_rate_id === id) {
                                    $option.prop('selected', true)
                                }
                                rates_options.push($option)
                            })
                            $shipping_ext_rates.append(rates_options)
                            $shipping_form.data('fallback', false)
                            $fields_block.removeClass('js-shipping-fields-hidden').find('input,select,textarea').prop('disabled', false)
                            $fallback_block.addClass('js-shipping-fields-hidden').find('input,select,textarea').prop('disabled', true)
                            $shipping_form.find('.error-msg.shipping').html('')
                            rates[shipping['id']] = shipping['rates']
                            $shipping_form.find('.js-shipping-rate').trigger('change')
                        }
                        if (is_error) {
                            $shipping_form.data('fallback', true)
                            $fields_block.addClass('js-shipping-fields-hidden').find('input,select,textarea').prop('disabled', true)
                            $shipping_form.find('.error-msg.shipping').html(shipping['error'] || shipping['comment'])
                            $fallback_block.removeClass('js-shipping-fields-hidden').find('input,select,textarea').prop('disabled', false)
                        }
                    }

                    //Update desired delivery dates
                    var $shipping_desired_dates = $shipping_form.find('.js-delivery-intervals-container')
                    if ($shipping_desired_dates.length) {
                        $shipping_desired_dates.data('intervals', shipping['desired_delivery_dates'])
                    }

                    //Update map
                    var $map = $('#js-map' + shipping['id'])
                    if ($map.length) {
                        SiteMap.renderDeliveryRates('delivery-' + shipping['id'], $map, rates[shipping['id']], selected_rate_id)
                    }
                }
                else {
                    $shipping.addClass('js-shipping-disabled')
                }
            })

            //Show first available shipping form if shipping unavailable
            var shipping_id = parseInt(response.data['shipping_id'])
            var selected_rate_id = response.data['rate_id'][shipping_id]
            if (parseInt($shipping_checked.val()) !== shipping_id) {
                $shipping_checked.prop('checked', false)
                $('#shipping-' + shipping_id).prop('checked', true)
                change_shipping_form(shipping_id)
                var $map = $('#js-map' + shipping_id)
                if ($map.length) {
                    SiteMap.renderDeliveryRates('delivery-' + shipping_id, $map, response.data['shipping'][shipping_id]['rates'], selected_rate_id)
                }
            } else if (force_update_shipping) {
                change_shipping_form(shipping_id)
            }
            $('.js-shipping .spinner').hide()

            //Hide unavailable payments
            $.each(response.data['payments'], function (i, payment) {
                var $payment = $('.js-payment[data-id=' + payment['id'] + ']')
                if (payment['available']) {
                    $payment.removeClass('js-payment-disabled')
                }
                else {
                    $payment.addClass('js-payment-disabled')
                }
            })
            var $payment_checked = $('.js-checkout-form [name=payment_id]:checked')
            if (parseInt($payment_checked.val()) !== parseInt(response.data['payment_id'])) {
                $payment_checked.prop('checked', false)
                $('#payment-' + response.data['payment_id']).prop('checked', true)
                change_payment_form(response.data['payment_id'])
            }

            $('.js-cart-total').text(format_price(response.data['cart_total']))
            $('.js-cart-discount').text(format_price(response.data['discount']))

            //If do not request rates from external service update shipping cost from saves rates in html
            if (response.data.shipping_id && response.data.shipping[response.data.shipping_id]['rates_skipped']) {
                $('#shipping-form-' + response.data.shipping_id).find('.js-shipping-rate').trigger('change')
            }
            else {
                $('.js-shipping-total').text(format_price(response.data['shipping_total']))
                $('.js-order-total').text(format_price(response.data['order_total']))
            }
        })
    }

    function parse_city_region (obj, with_type) {
        var result = {
            'city': '',
            'city_name': '',
            'city_type': 'city',
            'region': '',
            'region_name': '',
            'region_id': '',
            'city_region': ''
        }
        if (obj.city) {
            result.city = with_type ?  obj.city_with_type : obj.city
            result.city_name = obj.city
        } else {
            result.city = (with_type ?  obj.settlement_with_type : obj.settlement) + ', ' + obj.area_with_type
            result.city_name = obj.settlement + ', ' + obj.area
            result.city_type = 'settlement'
        }
        if (obj.region_kladr_id) {
            result.region_id = obj.region_kladr_id.substr(0, 2)
            if (obj.region !== result.city_name) {
                result.region = obj.region_with_type
                result.city_region = result.city + ', ' + result.region
                result.region_name = obj.region
            }
            else {
                //Москва не имеет печатного региона (совпадает с городом), но имеет region_id
                result.city_region = result.city
            }
        } else if (obj.region) {
            result.region = ''
            result.city_region = result.city
        }
        return result
    }

    function init_city_select() {
        var $country =  $('.js-country-select'),
            country = $country.val(),
            country_name = $country.find('option:checked').text()
        $('.js-city-select').suggestions({
            token: dadata_key,
            type: 'ADDRESS',
            bounds: 'city-settlement',
            constraints: {
                locations: { country: country_name }
            },
            hint: false,
            count: 10,
            formatResult: function (value, currentValue, suggestion) {
                var data = parse_city_region(suggestion.data, true)
                //suggestion.value = data.city_region

                return data.city_region
            },
            formatSelected: function (suggestion) {
                var data = parse_city_region(suggestion.data, false)
                return data.city_region
            },
            /* Вызывается, когда пользователь выбирает одну из подсказок */
            onSelect: function (suggestion) {
                var data = parse_city_region(suggestion.data, false)
                $('.js-bind-country').val(country)
                $('.js-bind-city').val(data.city)
                $('.js-bind-region-id').val(data.region_id)
                $('.js-bind-region').val(data.region)
                $('.js-street-search').data('region', data.region_name).data('city', data.city)
                request_update_checkout(true, true)
            },
        })
    }
    //

    init_city_select()
    $(document).on('change', '.js-country-select', function () {
        init_city_select()
        $('.js-city-select').val('')
        $('.js-bind-country').val($(this).val())
        $('.js-bind-city').val('')
        $('.js-bind-region-id').val('')
        $('.js-bind-region').val('')
        $('.js-street-search').data('region', '').data('city', '')
    })

    // Update shipping in checkout,
    // * Show shipping form
    // * Hide unavailable payments
    $(document).on('change', '.js-checkout-form [name=shipping_id]', function () {
        change_shipping_form($(this).val())
        request_update_checkout(false)
    })

    // Update payment in checkout,
    // * Show payment form
    $(document).on('change', '.js-checkout-form [name=payment_id]', function () {
        change_payment_form($(this).val())
    })

    //If checkout checkout update current shipping form and trigger default payment
    if ($('.js-checkout-form').length) {
        change_shipping_form($('.js-checkout-form [name=shipping_id]:checked').val())
        var payment_id = $('.js-checkout-form [name=payment_id]:checked').val()
        $(document).trigger('paymentChange', [$('#payment-' + payment_id).data('gtm-name')])
    }

    //If checkout contain shippings with api rates, update this via ajax
    if ($('.js-checkout-form [data-shipping-external]').length) {
        request_update_checkout(true)
    }

    //Recalc order total after change rate with new cost
    function update_shipping_cost (shipping_cost) {
        var $checkout = $('.js-checkout-form')
        $('.js-shipping-total').text(format_price(shipping_cost))
        $('.js-order-total').text(format_price($checkout.data('cart-total') + shipping_cost))
    }

    //Rate changed
    $(document).on('change', '.js-checkout-form .js-shipping-rate', function () {
        var $select = $(this)
        if ($select.prop('disabled')) {
            return
        }
        var $option = $select.find('option:selected'),
            $form = $select.closest('.js-shipping-form')
        $form.find('.js-shipping-comment').html($option.data('comment') || '')
        if ($option.data('type')) {
            $form.find('.js-shipping-fields-type').not('.js-shipping-fields-type-' + $option.data('type')).hide()
            $form.find('.js-shipping-fields-type-' + $option.data('type')).show()
        }
        if (typeof $option.data('rate') !== 'undefined') {
            update_shipping_cost($option.data('rate'))
        }
        $(document).trigger('rate-change.cf', [$option.prop('value'), 'delivery-' + $form.data('shipping-id')])
    })

    //Rate changed from map
    $(document).on('click', '.js-checkout-form .js-rate-select-btn', function (e) {
        e.preventDefault()
        $('.js-checkout-form .js-shipping-rate').val($(this).data('rate_id')).trigger('change')
    })

    //Autoselect city on focus
    $(document).on('focus', '.js-city-select', function () {
        $(this).select()
    })

    var change_user_type = function (user_type) {
        $('.js-auth-form').find('input').prop('disabled', user_type === 0)
        $('.js-checkout-form').find('input, select, textarea').prop('disabled', user_type === 1)
    }
    //Change user type
    $(document).on('click', '.js-user-type', function () {
        change_user_type(parseInt($(this).data('user-type')))
    })

    change_user_type(parseInt($('.js-user-type.active').data('user-type')))

    //Company Autocomplete
    var init_inn_suggestions = function ($container) {
        $container.find('.js-company-search').suggestions({
            token: dadata_key,
            type: 'PARTY',
            count: 5,
            params: {
                status: ['ACTIVE'],
            },
            /* Вызывается, когда пользователь выбирает одну из подсказок */
            onSelect: function (suggestion) {
                $(this).val('')
                var data = suggestion.data,
                    $form = $(this).closest('.shopcart-form__company')
                if (data.name) {
                    $('.js-company-name').val(data.name.short_with_opf || data.name.full_with_opf)
                }
                $form.find('.js-company-inn').val(data.inn)
                $form.find('.js-company-kpp').val(data.kpp)
                if (data.address) {
                    $form.find('.js-company-legal-address').val(data.address.value)
                }
            },
        })
    }

    $(document).on('change', '.js-delivery-date', function () {
        update_delivery_intervals($(this).closest('.js-shipping-form '))
    })

    update_delivery_dates($('#shipping-form-' + $('.js-checkout-form [name=shipping_id]:checked').val()))

    $('.js-checkout-form').on('submit', function() {
        var $form = $(this);
        if ($form.valid()) {
            $form.find('.js-checkout-btn').prop('disabled', true)
        }
    })

    $(document).on('change', '.js-checkout-form .shopcart-form__input', function() {
        var $form = $(this).closest('.js-checkout-form');
        var $label = $('.js-checkout-form .shopcart-form__error');
        $label.text($label.data('error-text')).addClass('active');
        if ($form.valid()) {
            $label.removeClass('active')
        } else {
            $label.addClass('active')
        }
    })
})
